import { FC, memo, Fragment } from 'react'

import { MathVaultLink } from '~/types/math-vault'

import MenuItem from './MenuItem'

interface SubMenuProps {
  item: MathVaultLink
  selected: string
  selectMenu: (path: string) => void
  level: number
}

const SubMenuComponent: FC<SubMenuProps> = ({ item, selected, selectMenu, level }) => {
  const path = item.path?.src ?? item.path
  const isSelected = selected.indexOf(path) === 0
  const subChapterHeight = isSelected ? 'max-h-fit-content xl:max-h-96' : 'max-h-0'

  return (
    <Fragment>
      <MenuItem isLink={!item.children} item={item} level={level} selected={selected} selectMenu={selectMenu}>
        {item.h1}
      </MenuItem>

      {isSelected && (
        <div className={`flex flex-col ml-4 ${subChapterHeight} transition-all duration-500 ease-in-out`}>
          {item.children?.map((subItem) => (
            <SubMenu item={subItem} key={subItem.key} level={level + 1} selected={selected} selectMenu={selectMenu} />
          ))}
        </div>
      )}
    </Fragment>
  )
}
const SubMenu = memo(SubMenuComponent)

export default SubMenu
